/**
 * Created by Mikhail Menshenin on 18.05.2026
 */

VictoryWindow = Prefab.createWindow("victory_window", "victorywindowprefab_json", {
    bundles: function (victoryRewards) {
        const personRole = cleverapps.persons.getRole("hero");
        const personBundles = personRole && personRole.bundle ? [personRole.bundle] : [];
        return ["victory_window"]
            .concat(victoryRewards.rewards.listBundles())
            .concat(personBundles);
    }
});
